export default __webpack_public_path__ + "static/media/hamburger.2cb5debe.svg";